module.exports = __webpack_public_path__ + "static/img/kjdy05.983a7f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy05.jpg
// module id = 1418
// module chunks = 0